import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

import {
  LandingFooter,
  LandingHeader,
  LandingServices,
  MetaHead,
} from '@/components/atomic';

export const Index: React.FC = () => {
  return (
    <>
      <MetaHead />
      <section className="mx-auto w-full max-w-[1200px] px-5">
        <LandingHeader />
        <LandingServices />
        <LandingFooter />
      </section>
    </>
  );
};

export default Index;

export async function getStaticProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}
